// extracted by mini-css-extract-plugin
export default {"section":"AdList_section__11+rc","inner":"AdList_inner__rDhth","adList":"AdList_adList__dy23n","adElement":"AdList_adElement__HoZ7a"};